export const setOpen = (isPollOpen) =>
({
    type: 'OPEN',
    payload: { isPollOpen }
});


export const resetPollList = (polls) =>
	({
		type    : 'RESET_POLL_LIST',
		payload : { polls }
	});

export const addPoll = (poll) =>
	({
		type    : 'ADD_POLL',
		payload : { poll }
	});

export const launchPoll = (poll,peerId) =>
	({
		type    : 'LAUNCH_POLL',
		payload : { poll, peerId }
	});

export const newAnsAddedPoll = (poll,peerId, newResult, noPeerAlreadyAnswer) =>
	({
		type    : 'ANSWER_POLL',
		payload : { poll, peerId, newResult, noPeerAlreadyAnswer }
	});

export const attendeeResultPublish = (poll,peerId, noPeerAlreadyAnswer) =>
	({
		type    : 'ATTENDEE_RESULT_PUBLISH',
		payload : { poll, peerId, noPeerAlreadyAnswer }
	});

export const showResultToAll = (isShowResult) =>
	({
		type    : 'SHOW_RESULT',
		payload : { isShowResult }
	});

export const endPoll = (value) =>
	({
		type    : 'END_POLL',
		payload : value
	});

export const forceClose = () =>
	({
		type    : 'FORCE_CLOSE',
		payload : {}
	});
	
	
